import { Component, OnInit, ViewEncapsulation, ViewChild, TemplateRef, Input , EventEmitter, Output} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ImageResult } from 'ngx-image2dataurl';
import { LocalStorage } from 'ngx-store';

//Service
import { TaskService } from '../../services/tasks.service';
import { UsersService } from '../../services/users.service';
import { FilesService } from '../../services/files.service';
import { User } from '../../model/users.model';

//Model
import { Task } from '../../model/tasks.model';
import * as moment from 'moment';

@Component({
    selector: 'app-addupdatetask',
    templateUrl: './addupdatetask.component.html',
    styleUrls: ['./addupdatetask.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [ TaskService , UsersService , FilesService ],
    exportAs: 'app-addupdatetask',
})
  
export class AddUpdateTaskComponent implements OnInit {
  	@Input() task: Task;
  	@Input() caller: string;
  	@Input() objectId: number;
  	@Output() closeModal : EventEmitter<any>= new EventEmitter<any>();
  	@LocalStorage() user: User;

    isEditMode: boolean = false;

    public frmTask: FormGroup; 
    public categories: any[];
    public users: any[];
    public incidents: any[];
    public repairs: any[];
    public reports: any[];
    public tickets: any[];
	public ca_report: any[];
    public statuses: any[];

    public frmFile: any;
    public fileExists :boolean;
    public fileRemove :boolean;
    public oldFile: string;

    private readonly prefixTask = 'tasks';
    private readonly incidentCode = 'incident';
    private readonly repairCode  = "repairrequest";
    private readonly reportCode = "report";
    private readonly ticketCode = "tickets";
	private readonly caReportCode = "ca_report";
	loadingIndicator: boolean = true;
	spinner: boolean = false;
 
    constructor(private http: HttpClient, 
    			private _fb: FormBuilder, 
    			private modal: NgbModal, 
                private fileService: FilesService, 
                private taskService: TaskService,
				private memberService: UsersService,
				private toastr: ToastrService
 				){
	}

    ngOnInit() {
    	this.initTaskForm();
		this.getMisc();
	
		if(this.task){
			this.isEditMode = true;
			this.frmTask.patchValue(this.task);
			
	        if (this.task.file != null && this.task.file != ''){
	          this.oldFile = this.task.file;
	          this.fileExists = true;
	        }
		} else{
			this.isEditMode = false;
			this.task = new Task();
		}
    }

    async getMisc(){
    	await this.taskService.getTaskCategories().toPromise().then(data=>{
    	  this.categories = data["categories"];
    	});

    	await this.memberService.getActiveMembers().toPromise().then(data=>{
		  this.users = data["members"];
    	});

    	await this.taskService.getTaskStatuses().toPromise().then(result => {
		  this.statuses = result['statuses']
		  setTimeout(() => { this.loadingIndicator = false; });
    	});
	}

    initTaskForm() {
        var category = 1;
		console.log("CALLER", this.caller)
        switch(this.caller){
            case(this.incidentCode):{category = 3; break;};
            case(this.ticketCode):{ category = 3; break;};
            case(this.reportCode):{ category = 2; break;};
            case(this.repairCode):{ category = 2; break;};
			case(this.caReportCode):{ category = 4; break;};
            default: {category=1; break;};
        }
        

		this.frmTask = this._fb.group({
		  id                : [''],
		  title             : ['', Validators.required],
		  date_due          : [''],
		  created_by        : [this.user.id],
		  assigned_to       : ['', Validators.required],
		  percent_done      : [0],
		  task_category_id  : [category],
		  status_id         : [1],
		  report_id         : [''],
		  incident_id       : [''],
		  repair_request_id : [''],
          ticket_id         : [''],
		  ca_report_id		: [''],
		  is_urgent         : [0],
		  file              : [''],
		  notes             : [''],
		  viewed_at         : [null],

		});

		switch(this.caller){
	    	case this.incidentCode:{ this.frmTask.controls.incident_id.setValue(this.objectId); break;}
	    	case this.repairCode:{ this.frmTask.controls.repair_request_id.setValue(this.objectId); break;}
	    	case this.reportCode:{ this.frmTask.controls.report_id.setValue(this.objectId); break;}
            case this.ticketCode:{ this.frmTask.controls.ticket_id.setValue(this.objectId); break;}
			case this.caReportCode:{ this.frmTask.controls.ca_report_id.setValue(this.objectId); break;}
	    	default:break;
	    };

	    if (this.isEditMode == false && this.task != null){
			this.frmTask.patchValue(this.task);
		}

		this.resetFileVariables();
    }

    public resetFileVariables(){
     	// for document file handling variables; checking if file exists or removed
        this.fileExists = false;
        this.fileRemove  = false;
        this.oldFile = '';
    }

    public createTask(task: Task) {
    	this.taskService.createTask(task).subscribe(task => {
    	});
    }

    async updateTask(task:Task) {
	    await this.taskService.updateTask(task).toPromise().then(task => {
			this.toastr.success('', task["message"], {
				timeOut: 5000,
				positionClass: 'toast-top-full-width',
				progressBar: true
			});
			this.getMisc();
			this.close();
	   	}).catch(response =>{
			this.toastr.error("Please try again.", "There was a problem with updating the selected task. ", {
				timeOut: 4000,
				positionClass: 'toast-top-full-width',
				progressBar: true
			});
		});
		console.log('updated Task');
    }

	verifyDateValuesTask(){
		if( (this.frmTask.value.date_due != null && !moment(this.frmTask.value.date_due, "YYYY-MM-DD", true).isValid()) ){
			return false;
		}
		else return true;
	}

	showInvalidDateToastr(){
		this.toastr.error('', 'Entered an invalid date!', {
		  timeOut: 2000,
		  positionClass: 'toast-top-full-width',
		  progressBar: true
		});
	}

    async onSubmitTask(task: Task) {
		if( this.verifyDateValuesTask() ){
			this.spinner = true;
			this.task = task;
			
			if (this.frmTask.valid) {
				this.task= task;
				
				if(task.id){
					this.updateTask(this.task);
					console.log('updating task...');
			}
			else{
				console.log('creating task...');
				await this.taskService.createTask(task).toPromise().then(task => {
					this.toastr.success('', task["message"], {
						timeOut: 4000,
						positionClass: 'toast-top-full-width',
						progressBar: true
					});
					this.task = task["data"];
					this.getMisc();
					this.close();   
				}).catch(response => {
					this.toastr.error("Please try again.", "There was a problem with creating new tasks.", {
						timeOut: 4000,
						positionClass: 'toast-top-full-width',
						progressBar: true
					});
				});
			}   
				console.log('created task...');
				this.uploadFile(this.task.file); 
			}
			this.spinner = false;
		}
		else this.showInvalidDateToastr();
    }

    public formatDate(inDate: string) {
    	let formatedDate: Date;
    	formatedDate = new Date(inDate.replace(/-/g, "/"));
    	return formatedDate;
    }	
  
    public getFile(event){
	    var taskFilename;

	    if (event == '' || event == null){
	      	taskFilename = event
	    }else{
			var file : ImageResult;
			file = event;
			taskFilename =  file.file.name;

			this.frmFile = event;
			this.frmTask.controls.file.setValue(file.file.name); 
    	}

  	}

  	public uploadFile(filename){
	    if (this.frmFile){

		this.fileService.uploadRawFileWithRename(this.prefixTask, this.frmFile, filename).subscribe(file=>{
		console.log('file uploaded....');

			if(file["data"] !== filename){
				this.task.file = file["data"];
				this.updateTask(this.task);
			}
        });
        
   		}
    	this.frmFile = '';

	    //handling files if replaced, old file is removed from server
	    if(this.fileRemove == true){
	        this.deleteFile(this.oldFile);
	    };
        this.close();
	}

	public removeFile(){
    	this.fileExists  = false;
    	this.frmTask.controls.file.setValue('');
    	this.fileRemove = true;
	}

  	public deleteFile(filename){
    	this.fileService.deleteFile(this.prefixTask, filename).subscribe(result=>{console.log(result);})
     	this.fileRemove = false;
  	}

  	public close(){
  		this.frmTask.reset();
        this.closeModal.emit();
  	}
}